import type { ThemeDefinition } from 'vuetify'
import { commonColors } from './common'

export const light: ThemeDefinition = {
    colors: {
        ...commonColors,
        secondary: '#f9f9f9'
    }
}
